<template>
  <MarketAssessmentsTab
    :product="product"
    :market-assessment-subscription="marketAssessmentSubscription"
    :show-latest-report-section-in-market-assessments="
      showLatestReportSectionInMarketAssessments
    "
  />
</template>

<script lang="ts" setup>
import MarketAssessmentsTab from '~/components/reports/MarketAssessmentsTab.vue'
import type { TProduct } from '~/src/types/product'
/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
withDefaults(
  defineProps<{
    marketAssessmentSubscription?: string
    product: TProduct
    showLatestReportSectionInMarketAssessments?: boolean
  }>(),
  {
    marketAssessmentSubscription: '',
    showLatestReportSectionInMarketAssessments: false,
  },
)
</script>
